/* Stylesheet */

.dropdown_container {
  position: absolute;
  min-height: 92px;
  max-height: 192px;
  width: 100%;
  z-index: 200;
  background: #294162;
  overflow: hidden;
  border-radius: 0px 0px 5px 5px;
}

.dark {
  .item {
    --padding-start: 21px;
    --min-height: 48px;
    --color: #c3cddc;
    --color-hover: #c3cddc;
    --background: transparent;
    --color-activated: #c3cddc;
  }
}
